@if (cpuUsage$ | async; as cpuUsage) {
  <div class="cpu-indicator">
    <div id="label">CPU</div>
    <div id="percentage">{{ cpuUsage }}%</div>
  </div>
}
